"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withTranslation = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var translation_1 = require("./translation");
function withTranslation(WrappedComponent) {
    return react_1.default.forwardRef(function (props, ref) {
        var t = translation_1.useTranslation();
        return react_1.default.createElement(WrappedComponent, tslib_1.__assign(tslib_1.__assign({}, props), { ref: ref, t: t }));
    });
}
exports.withTranslation = withTranslation;
//# sourceMappingURL=withTranslation.js.map